import React from "react"
import {StyledHeading} from "./components"
import type {HeadingProps, HeadingStyles} from "./models"
import {getSearchBannerComponentTestId} from "../utils"

export const Heading = ({overrideStyles, content, isIntelRecs}: HeadingProps) => {
    const {text} = content
    return (
        <StyledHeading
            variant="h2"
            component="h2"
            $headingStyles={overrideStyles as HeadingStyles}
            data-testid={getSearchBannerComponentTestId(isIntelRecs, "heading")}
        >
            {text}
        </StyledHeading>
    )
}

export default Heading
